export const victimologyData = [
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-12',
    dateInfected: '2021-04-01',
    targetIndustry: 'Private Company',
    targetCountry: 'Poland',
    sourceCountry: 'Poland',
    confidenceRating: 'Low',
    recievedApple: 'Unknown',
    reason: 'Political Targeting',
    targetRatingConfidence: 'Medium',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-5',
    dateInfected: '2021-02-01',
    targetIndustry: 'Unknown',
    targetCountry: 'Unknown',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Unknown',
    reason: 'Unknown',
    targetRatingConfidence: 'Unknown',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-12',
    dateInfected: '2021-03-01',
    targetIndustry: 'Unknown',
    targetCountry: 'Unknown',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Unknown',
    reason: 'Unknown',
    targetRatingConfidence: 'Unknown',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-5',
    dateInfected: '2021-05-01',
    targetIndustry: 'Unknown',
    targetCountry: 'Unknown',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Unknown',
    reason: 'Unknown',
    targetRatingConfidence: 'Unknown',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-9',
    dateInfected: '2021-04-01',
    targetIndustry: 'Unknown',
    targetCountry: 'Unknown',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Unknown',
    reason: 'Unknown',
    targetRatingConfidence: 'Unknown',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-12',
    dateInfected: '2021-02-01',
    targetIndustry: 'Unknown',
    targetCountry: 'Unknown',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Unknown',
    reason: 'Unknown',
    targetRatingConfidence: 'Unknown',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Public & Private IOC',
    dateDetected: '2024-12',
    dateInfected: '2021-07-01',
    targetIndustry: 'Government',
    targetCountry: 'Czech',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Yes',
    reason: 'Unknown',
    targetRatingConfidence: 'Unknown',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-12',
    dateInfected: '2021-09-01',
    targetIndustry: 'Finance',
    targetCountry: 'Unknown',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'No',
    reason: 'Unknown',
    targetRatingConfidence: 'Unknown',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-5',
    dateInfected: '2021-04-01',
    targetIndustry: 'Unknown',
    targetCountry: 'Unknown',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Unknown',
    reason: 'Unknown',
    targetRatingConfidence: 'Unknown',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Public IOC',
    dateDetected: '2025-1',
    dateInfected: 2021,
    targetIndustry: 'Unknown',
    targetCountry: 'Jordan',
    sourceCountry: 'Jordan',
    confidenceRating: 'Medium',
    recievedApple: 'Yes',
    reason: 'Journalism',
    targetRatingConfidence: 'High',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-10',
    dateInfected: '2021-02-01',
    targetIndustry: 'Government',
    targetCountry: 'SA',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Yes',
    reason: 'Government',
    targetRatingConfidence: 'Medium',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-12',
    dateInfected: '2021-03-01',
    targetIndustry: 'Unknown',
    targetCountry: 'Unknown',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Unknown',
    reason: 'Unknown',
    targetRatingConfidence: 'Unknown',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-7',
    dateInfected: '2021-01-01',
    targetIndustry: 'Government',
    targetCountry: 'SA',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Yes',
    reason: 'Government',
    targetRatingConfidence: 'Medium',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-12',
    dateInfected: '2021-04-01',
    targetIndustry: 'Unknown',
    targetCountry: 'Unknown',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Unknown',
    reason: 'Unknown',
    targetRatingConfidence: 'Unknown',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-7',
    dateInfected: '2021-01-01',
    targetIndustry: 'Government',
    targetCountry: 'SA',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Yes',
    reason: 'Government',
    targetRatingConfidence: 'Medium',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Public & Private IOC',
    dateDetected: '2024-7',
    dateInfected: '2021-03-01',
    targetIndustry: 'CEO Private Company',
    targetCountry: 'UAE',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Unknown',
    reason: 'Unknown',
    targetRatingConfidence: 'Low',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2025-1',
    dateInfected: '2021-05-01',
    targetIndustry: 'Finance',
    targetCountry: 'Armenia',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Yes',
    reason: 'Unknown',
    targetRatingConfidence: 'Low',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2025-2',
    dateInfected: '2021-05-01',
    targetIndustry: 'Business Executive',
    targetCountry: 'Jordan',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Unknown',
    reason: 'Unknown',
    targetRatingConfidence: 'Unknown',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Public IOC',
    dateDetected: '2025-1',
    dateInfected: '2021-02-01',
    targetIndustry: 'Unknown',
    targetCountry: 'Jordan',
    sourceCountry: 'Jordan',
    confidenceRating: 'Medium',
    recievedApple: 'Yes',
    reason: 'Journalism',
    targetRatingConfidence: 'High',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-12',
    dateInfected: '2022-10-01',
    targetIndustry: 'Government',
    targetCountry: 'Czech',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Yes',
    reason: 'Unknown',
    targetRatingConfidence: 'Low',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2022,
    detectedBy: 'Private IOC',
    dateDetected: '2025-1',
    dateInfected: '2022-10-01',
    targetIndustry: 'Government',
    targetCountry: 'Armenia',
    sourceCountry: 'Azerbaijan',
    confidenceRating: 'Low',
    recievedApple: 'Yes',
    reason: 'AR - AZ Conflict',
    targetRatingConfidence: 'Low',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2022,
    detectedBy: 'Private IOC',
    dateDetected: '2024-1',
    dateInfected: '2022-10-01',
    targetIndustry: 'Journalism',
    targetCountry: 'Jordan',
    sourceCountry: 'Jordan',
    confidenceRating: 'Medium',
    recievedApple: 'Yes',
    reason: 'Journalism',
    targetRatingConfidence: 'High',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2022,
    detectedBy: 'Private IOC',
    dateDetected: '2024-10',
    dateInfected: '2022-01-01',
    targetIndustry: 'Human Rights Activist',
    targetCountry: 'Serbia',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Unknown',
    reason: 'Human Rights Activist',
    targetRatingConfidence: 'High',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2023,
    detectedBy: 'Private IOC',
    dateDetected: '2024-12',
    dateInfected: '2023-08-01',
    targetIndustry: 'Physical Security',
    targetCountry: 'Czech',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'Yes',
    reason: 'Unknown',
    targetRatingConfidence: 'Unknown',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2023,
    detectedBy: 'Public IOC',
    dateDetected: '2023-11',
    dateInfected: '2023-2024',
    targetIndustry: 'Journalism',
    targetCountry: 'India',
    sourceCountry: 'India',
    confidenceRating: 'Low',
    recievedApple: 'Yes',
    reason: 'Journalism',
    targetRatingConfidence: 'High',
  },
  {
    spyware: 'Pegasus',
    spywareVersion: 2021,
    detectedBy: 'Private IOC',
    dateDetected: '2024-12-01',
    dateInfected: '2021-04-01',
    targetIndustry: 'Business Executive',
    targetCountry: 'Bahrain',
    sourceCountry: 'Unknown',
    confidenceRating: 'Low',
    recievedApple: 'No',
    reason: 'Unknown',
    targetRatingConfidence: 'Low',
  },

  {
    spyware: 'APT',
    spywareVersion: 2024,
    detectedBy: 'Suspicious Crash Logs',
    dateDetected: '2024-12-01',
    dateInfected: '2024-12-01',
    targetIndustry: 'Journalism',
    targetCountry: 'United States',
    sourceCountry: 'China',
    confidenceRating: 'Low',
    recievedApple: 'No',
    reason: 'Journalism',
    targetRatingConfidence: 'High',
  },
  {
    spyware: 'APT',
    spywareVersion: 2024,
    detectedBy: 'Suspicious Events',
    dateDetected: '2024-10-01',
    dateInfected: '2024-02-01',
    targetIndustry: 'Government',
    targetCountry: 'United States',
    sourceCountry: 'China',
    confidenceRating: 'Low',
    recievedApple: 'No',
    reason: 'Government',
    targetRatingConfidence: 'High',
  },
]
